<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>登陆赠送代金券管理</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="活动名称">
          <el-input v-model="formSearch.name" placeholder="活动名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getActivityLogin">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="handleOpen">创建活动</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" size="mini">
        <el-table-column prop="id" label="活动模板ID" width="90">
        </el-table-column>
        <el-table-column prop="name" label="活动名称">
        </el-table-column>
        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <span>{{formatActiviDate(scope.row.starttime)}}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{formatActiviDate(scope.row.endtime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pondMoney" label="奖池金额" width="120"></el-table-column>
        <el-table-column prop="usePondMoney" label="已赠金额" width="120"></el-table-column>
        <el-table-column prop="bz" label="备注" width="180"></el-table-column>
        <el-table-column prop="state" label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.state =='1'">待上线</span>
            <span v-if="scope.row.state =='2'">已上线</span>
            <span v-if="scope.row.state =='3'">已结束</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">详情预览</el-button>
            <el-divider v-if="scope.row.state === '1'" direction="vertical"></el-divider>
            <el-button v-if="scope.row.state === '1'" type="text" size="small" @click="handleLineClick(scope.row)">上线</el-button>
            <el-divider v-if="scope.row.state === '2'" direction="vertical"></el-divider>
            <el-button v-if="scope.row.state === '2'" type="text" size="small" @click="handleUnLineClick(scope.row)">下线</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;margin:10px"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-drawer :visible.sync="drawerShow" :with-header="false" size="60%">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>活动详情</span>
          </div>
          <el-form :model="showForm" label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="showForm.name" readonly></el-input>
            </el-form-item>
            <el-form-item label="活动备注" prop="bz">
              <el-input type="textarea" v-model="showForm.bz" readonly></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="activityDate">
              <el-date-picker
                readonly
                v-model="showForm.activityDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动奖池金额">
              <el-input v-model="showForm.pondMoney" readonly></el-input>
            </el-form-item>
            <el-form-item label="活动参与次数">
              {{showForm.partakeState == '1' ? '每个登录用户参与'+showForm.partakeCount+'次':'每个登录用户每天参与'+showForm.partakeCount+'次'}}
            </el-form-item>
            <el-form-item label="代金券礼包设置">
              <el-table :data="showForm.couponRule" size="mini">
                <el-table-column prop="denomin" label="面额" width="60">
                </el-table-column>
                <el-table-column prop="second" label="消费次数" width="80">
                  <template slot-scope="scope">
                    {{scope.row.second === -1?'不限次':scope.row.second}}
                  </template>
                </el-table-column>
                <el-table-column prop="quota" label="消费金额门槛" width="100">
                </el-table-column>
                <el-table-column prop="range" label="应用范围" width="100">
                </el-table-column>
                <el-table-column label="有效时间">
                  <template slot-scope="scope">
                    <span>{{formatActiviDate(scope.row.startDate)}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{formatActiviDate(scope.row.endDate)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="activityDate" label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.range == '指定应用'" @click="handleShowApplyClick(scope.row.applyList)" type="text" size="small">查看应用</el-button>
                    <el-button @click="handleShowModelClick(scope.row.modelData)" type="text" size="small">查看机型</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
        </el-card>
    </el-drawer>


    <el-drawer :visible.sync="drawer" :with-header="false" size="60%">
        <el-card shadow="never" class="drawer_body_100">
          <div slot="header" class="clearfix">
            <span>活动内容</span>
          </div>

          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="活动备注" prop="bz">
              <el-input type="textarea" v-model="ruleForm.bz"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="starttime">
              <el-date-picker
                v-model="ruleTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleRuleTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动奖池金额" prop="pondMoney">
              <el-input v-model="ruleForm.pondMoney"></el-input>
            </el-form-item>
            <el-form-item label="活动参与次数" prop="partakeState">
              <el-radio-group v-model="ruleForm.partakeState">
                <el-radio :label="1">每个登录用户参与<el-input-number v-model="ruleForm.partakeCount" :controls="false" style="width:50px"></el-input-number>次</el-radio>
                <el-radio :label="2">每个登录用户每天参与<el-input-number v-model="ruleForm.partakeCount" :controls="false" style="width:50px"></el-input-number>次</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="代金券礼包设置" prop="couponRule">
              <el-button type="info" @click="addRow">添加代金券规则</el-button>
              <el-table :data="ruleForm.couponRule" style="width: 100%" size="mini">
                <el-table-column prop="denomin" label="面额"></el-table-column>
                <el-table-column prop="second" label="消费次数"></el-table-column>
                <el-table-column prop="quota" label="消费金额门槛"></el-table-column>
                <el-table-column prop="range" label="消费应用范围"></el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="delRowClick(scope.$index, scope.row)" type="text" size="small">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm">确认保存</el-button>
            </el-form-item>
          </el-form>

        </el-card>
    </el-drawer>

    <!-- 代金券消费规则设置 -->
    <el-dialog title="代金券消费规则设置" :visible.sync="dialogVisible" :before-close="handleClose" width="50%">
      <el-form :model="couponForm" :rules="couponFormRules" ref="couponForm" label-width="auto" size="mini">
        <el-form-item label="代金券面额" prop="denomin">
          <el-input v-model="couponForm.denomin">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="消费次数设置" prop="secondState">
          <el-radio-group v-model="couponForm.secondState" @change="onSecondRange">
            <el-radio label="0">消费<el-input-number type="number" v-model="couponForm.second" :controls="false" style="width:50px"></el-input-number>次</el-radio>
            <el-radio label="-1">不限次数</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消费金额门槛" prop="quota">
          <!--  oninput="value=value.replace(/[^\d.]/g,'')" -->
          <el-input v-model="couponForm.quota"></el-input>
        </el-form-item>
        <el-form-item label="有效时间设置" prop="startDate">
          <el-date-picker
            v-model="ruleCouponTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleRuleCouponTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="消费应用范围" prop="range">
          <el-radio-group v-model="couponForm.range" @change="onRange">
            <el-radio label="全平台应用"></el-radio>
            <el-radio label="指定应用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入应用" v-show="couponForm.flag">
          <el-upload
            :action="`${this.$store.state.upBaseUrl}coupon-market/activity/fileUpload`"
            :headers="myHeaders"
            :limit="1"
            ref="upload"
            accept=".txt"
            :on-success="handleAvatarSuccess"
            :auto-upload="true">
            <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件，每次只能上传一个文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="指定机型">
          <sam-phone-model @setPhoneModel="setPhoneModel" ref="childModel"></sam-phone-model>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTableRow">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 机型列表 -->
    <el-dialog title="机型列表" :visible.sync="dialogTableVisible">
      <el-table ref="multipleTable" tooltip-effect="dark" :data="phoneData">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column property="phoneModel" label="机型"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectionModel">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看机型 -->
    <el-dialog title="机型列表" :visible.sync="dialogModelTableVisible">
      <el-link type="info" v-for="model in modelData"  key="index">【{{model.phoneModel}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogModelTableVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看应用 -->
    <el-dialog title="查看应用" :visible.sync="dialogApplyVisible">
      <el-link type="info" v-for="apply in applyData" key="index">【{{apply.applyNo}}{{apply.applyName}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogApplyVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import PhoneModel from '../components/phoneModel'
export default {
  components:{
      'sam-phone-model':PhoneModel
  },
  data () {
    return {
      myHeaders:{},
      ruleTime:[],
      ruleCouponTime:[],
      applyData:[],
      modelData:[],
      dialogApplyVisible:false,
      dialogModelTableVisible:false,
      dialogVisible:false,//代金券消费规则设置
      dialogTableVisible:false,//机型列表
      phoneData:[],//机型列表
      tableData:[],//列表
      pageresult:{},//分页
      showForm:{},//查看用
      ruleForm: {
        name: '',
        bz: '',
        starttime: '',
        endtime: '',
        pondMoney:'',//活动奖池金额
        couponRule:[],//代金券礼包设置
        partakeState:'',//活动参与类型
        partakeCount:'',//活动参与次数
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        starttime: [
          { required: true, message: '请选择活动时间', trigger: 'change' }
        ],
        pondMoney: [
          { required: true, message: '请输入活动奖池金额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        partakeState: [
          { required: true, message: '请输入活动参与次数', trigger: 'blur' }
        ],
        couponRule: [
          { required: true, message: '请设置优惠券规则', trigger: 'change' }
        ],

      },
      couponForm: {
        flag: false,
        denomin: '',
        second: '',
        secondState: '',
        quota:'',
        startDate:'',
        endDate:'',
        range:'',
        applyList:[],//指定应用时 上传的应用列表
        modelData:[],//已选机型列表
      },
      couponFormRules: {
        denomin: [
          { required: true, message: '请输入代金券面额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        secondState: [
          { required: true, message: '请选择消费次数', trigger: 'change' }
        ],
        quota: [
          { required: true, message: '请输入消费金额门槛', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        startDate: [
          { required: true, message: '请选择有效时间', trigger: 'blur' }
        ],
        range: [
          { required: true, message: '请选择应用范围', trigger: 'change' }
        ]
      },
      drawer: false,
      drawerShow: false,
      formSearch: {
        name: '',
        pageNum:1
      }
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
    this.getActivityLogin();
  },
  methods: {
    setPhoneModel(models){
      this.couponForm.modelData = models;
    },
    // handleCouponClick(row){
    //   let that = this;
    //   this.$confirm('确认是否继续?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       that.$ajax({
    //         url:"coupon-market/activity_user/addCouponByActivityUser",
    //         async:false,
    //         methods:'GET',
    //         data:{'id':row.id},
    //         token:window.sessionStorage.getItem('token'),
    //         success:function(response){
    //           if (response.code==0) {
    //             that.$message(response.message);
    //           }else{
    //             that.$message.error(response.message);
    //           }
    //         },
    //         error:function(){
    //           that.$message.error("请求失败");
    //         }
    //       })
    //   });
    // },
    handleShowApplyClick(data){
      this.applyData = data;
      this.dialogApplyVisible = true;
    },
    handleShowModelClick(data){
      this.modelData = data;
      this.dialogModelTableVisible = true;
    },
    handleClick(row){
      this.drawerShow = true;
      this.showForm = row;
      this.showForm.activityDate = [row.starttime,row.endtime]
    },
    handleUnLineClick(row){
      let that = this;
      this.$confirm('此下线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$ajax({
            url:"coupon-market/activity_login/saveGoUnLine",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.getActivityLogin();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        });
    },
    handleLineClick(row){
      let that = this;
      this.$confirm('此上线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$ajax({
            url:"coupon-market/activity_login/saveGoLine",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.getActivityLogin();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        });
    },
    delRowClick(index,row){
      this.ruleForm.couponRule.splice(index,1);
    },
    handleClose(done) {
      this.resetFormCoupon("couponForm");
      this.dialogVisible = false;
    },
    addRow(){
      this.dialogVisible = true;
    },
    addTableRow(){
      let _this = this;
      this.$refs.couponForm.validate((valid) => {
        if (valid) {
          let row = Object.assign({},_this.couponForm);//Object.create(_this.couponForm);
          var timestamp = (new Date()).valueOf();
          row.id = timestamp;
          _this.ruleForm.couponRule.push(row);
          _this.resetFormCoupon("couponForm");
          _this.dialogVisible = false;
        } else {
          _this.$message.error('error submit!!');
          return false;
        }
      });
    },
    handleCurrentChange(val) {
      this.formSearch.pageNum=val;
      this.getActivityLogin();
    },
    handleOpen() {
      this.drawer=true
    },
    formatActiviDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    submitForm(){
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-market/activity_login/saveActivityUser",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.resetForm("ruleForm");
                that.drawer = false;
                that.getActivityLogin();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleTime = [];
      this.ruleForm.partakeCount = '';
      this.ruleForm.partakeCount = '';
      this.$refs[formName].resetFields();
    },
    resetFormCoupon(formName) {
      this.ruleCouponTime = [];
      this.couponForm.secondState = '';
      this.couponForm.second = '';
      this.$refs.upload.clearFiles();
      this.$refs.childModel.handleClear();
      this.$refs[formName].resetFields();
    },
    getActivityLogin(){
      let that = this;
      let info = this.$store.state.userInfo;
      that.formSearch.czybh = info.userbh;
      this.$ajax({
        url:"coupon-market/activity_login/getActivityLoginPage",
        async:false,
        data:that.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.tableData=response.data.content;
            that.pageresult = response.data;
          }else{
            that.$message.error(response.message);
          }
        }
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.couponForm.applyList=res.data
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    handleAvatarCouponUserSuccess(res, file){
      if (res.code == 0) {
        this.ruleForm.users=res.data
      }
    },
    onRange(value){
      if (value === "指定应用") {
        this.couponForm.flag = true;
      }else {
        this.couponForm.flag = false;
      }
    },
    onSecondRange(val){
      console.log(val,"============");
      if (val === "-1") {
        this.couponForm.second = "-1";
      }
    },
    openPhoneModel(){
      let _this = this;
      if(this.phoneData.length == 0){
        this.$ajax({
          url:"coupon-system/data/phoneModel",
          async:false,
          token:window.sessionStorage.getItem('token'),
          success:function(response){
            if (response.code == 0) {
              _this.phoneData = response.data;
              _this.dialogTableVisible = true;
            }else{
              _this.$message.error(response.message);
            }
          },
          error:function(){
            _this.$message.error("请求失败");
          }
        })
      }else{
        this.dialogTableVisible = true;
      }

    },
    selectionModel(){
      let data = this.$refs.multipleTable.selection || [];
      let models = Object.assign([],data);
      this.couponForm.modelData = models;//Object.assign();
      this.dialogTableVisible = false;
    },
    handleRuleTime(){
      if (this.ruleTime != null) {
				this.ruleForm.starttime = this.ruleTime[0];
				this.ruleForm.endtime = this.ruleTime[1];
			}
    },
    handleRuleCouponTime(){
      this.couponForm.startDate = this.ruleCouponTime[0];
      this.couponForm.endDate = this.ruleCouponTime[1];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/merch/mer_activity_login.vue